import {query} from '@albert-io/json-api-framework/request/builder';
import {genericMandarkRequest} from 'resources/mandark.resource';

import {
  managedUserErrorMap,
  getOfflineValidations,
  getServerValidations
} from './useCreateAccounts.validators';

const endpoint = query()
  .mandarkEndpoint(['managed_users_v1'])
  .customHeader({'Content-Type': 'application/vnd.api+json; ext=bulk'})
  .done();

function addManagedUsersQuery(payload) {
  return genericMandarkRequest('post', endpoint, payload, {raw: true});
}

// --------- Query handlers -------------
export const makeManagedUsersPayload = (coppaConsentGrantorEmail, school, payload) => {
  return payload.reduce(
    (prev, curr) => {
      prev.data.push({
        attributes: {
          coppa_consent_email: coppaConsentGrantorEmail,
          email: curr.get('email'),
          onboarding_steps: [
            'ACCOUNT_TYPE_SELECTION',
            'COPPA_AGE_SCREENER',
            'PARENTAL_CONSENT',
            'ACCOUNT_COMPLETION'
          ],
          password: curr.get('password'),
          username: curr.get('username'),
          first_name: curr.get('firstName'),
          last_name: curr.get('lastName')
        },
        relationships: {
          schools_v5: {
            data: [
              {
                id: school.getId(),
                type: 'school_v5'
              }
            ]
          }
        }
      });
      return prev;
    },
    {data: []}
  );
};

const managedUserErrors = [
  managedUserErrorMap.DUPLICATE_EMAIL,
  managedUserErrorMap.DUPLICATE_USERNAME,
  managedUserErrorMap.UNIQUE_EMAIL_CONSTRAINT_VIOLATED,
  managedUserErrorMap.UNIQUE_USERNAME_CONSTRAINT_VIOLATED
];

const hasParseableError = (error) => {
  if (error?.response?.body?.errors.some((err) => managedUserErrors.includes(err.code))) {
    return true;
  }
  return false;
};

const bulkCreateSchoolAccounts = async (
  records,
  emailDomains,
  coppaConsentGrantorEmail,
  school
) => {
  const offlineValidationsResults = getOfflineValidations(records, emailDomains);

  const {invalidEntries, validEntries} = offlineValidationsResults;

  const payload = makeManagedUsersPayload(coppaConsentGrantorEmail, school, validEntries);

  try {
    const res = await addManagedUsersQuery(payload);
    // no errors! all was able to be created, no duplicates or existing
    return {response: res, validEntries, invalidEntries, error: null};
  } catch (errResponse) {
    if (hasParseableError(errResponse)) {
      const validatedResults = getServerValidations(
        offlineValidationsResults.entries,
        emailDomains,
        errResponse
      );
      const retryPayload = makeManagedUsersPayload(
        coppaConsentGrantorEmail,
        school,
        validatedResults.validEntries
      );
      try {
        if (validatedResults.validEntries.isEmpty()) {
          throw new Error('Bulk create failed with all unique constraint violations');
        }
        const res = await addManagedUsersQuery(retryPayload);
        return {
          response: res,
          ...validatedResults,
          error: null
        };
      } catch (lastError) {
        // TODO: add handler for generic unhandled error message for csv
        return {response: null, error: lastError, ...validatedResults};
      }
    } else {
      // uncaught error
      // TODO: add handler for generic unhandled error message for csv
      return {
        error: errResponse
      };
    }
  }
};

export default bulkCreateSchoolAccounts;
